<template>
	<div class="layout-topbar" style="background-color: rgb(126, 214, 230);">
		<router-link to="/" class="layout-topbar-logo">
			<!-- <img alt="Logo" :src="darkTheme ? require(`@/assets/layout/images/wilmar-logo.png@`) : '@/assets/layout/images/wilmar-logo.png'" /> -->
			<img alt="Logo" :src="'/assets/layout/images/wilmar-logo2.png'" />
			<span>PAP</span>
			<sup style="font-size: 7pt; font-weight: bold;color: blue;">&nbsp;&nbsp;[{{ this.$store.getters.getServer }}]</sup>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" v-styleclass="{
			selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
		}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li>
				<div class="layout-topbar-button topbar-display-name">
					<p style="color: black;">	{{ this.displayName }}
					<br />
						{{ this.username }}</p>
					<Divider layout="vertical" />
				</div>
			</li>
			<!-- <li>
				<button class="p-link layout-topbar-button" @click="toggleChangelog">
					<i class="pi pi-list"></i>
					<span style="display:none">Changelog</span>
				</button>
			</li> -->
			<li>
				<button v-if="!isContractor" class="p-link layout-topbar-button" @click="toggleGeneralInformation">
					<i class="pi pi-list"></i>
					<span style="display:none">General Information</span>
					<Menu ref="generalMenu" :model="generalItems" :popup="true" />
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="toggleLanguage">
					<i class="pi pi-globe p-text-secondary" v-badge="badgeLang"></i>
					<span>Language</span>

					<Menu ref="languageMenu" :model="languageItems" :popup="true" />
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="toggle">
					<i class="pi pi-spin pi-cog"></i>
					<span style="display:none">Settings</span>
					<Menu ref="menu" :model="items" :popup="true" />
				</button>
			</li>
		</ul>
	</div>

	<ChangePassword v-if="changePassword" :isVisible="changePassword" :userId="username" :requireCurrentPassword="true"
		@hide="hideChangePasswordDialog" @block-ui="blockUI" @unblock-ui="unblockUI" />
</template>

<script>
export default {
	emits: ['menu-toggle','toggle-changelog','block-ui','unblock-ui'],
	data() {
		return {
			changePassword: false,
			generalDataItems: [],
			isContractor : this.$store.getters.getIsContractor,
		}
	},
	mounted() {
 		this.loadGeneralItems();
	},
	methods: {
		hideChangePasswordDialog(event) {
			this.changePassword = false;
			this.errormessage = "";

			if (event && event.success) {
				this.$toast.add({ severity: 'success', summary: "Success", detail: event.message, life: 120000 });
			}
		},
		loadGeneralItems() {
			this.$emit("block-ui");

			this.$axios.get(this.$API_URL + "list/generalInformationItem")
				.then((response) => {
					
					const menus = response.data.data || []
					this.generalDataItems = menus.map(menu => ({
						label: menu.name,
						command: () => {
							this.$router.push(`/GeneralInformation/${menu.controller}`);
						}
					}));

					this.$emit("unblock-ui");
				})
				.catch(() => {
					this.$toast.add({
						severity: "error",
						summary: "Error",
						detail: "Gagal memuat menu",
						life: 3000
					});
					this.$emit("unblock-ui");
				});
		},
		blockUI() {
			this.$emit("block-ui");
		},
		unblockUI() {
			this.$emit("unblock-ui");
		},
		onMenuToggle(event) {
			this.$emit('menu-toggle', event);
		},
		toggle(event) {
			this.$refs.menu.toggle(event);
		},
		toggleLanguage(event) {
			this.$refs.languageMenu.toggle(event);
		},
		toggleGeneralInformation(event) {
			this.$refs.generalMenu.toggle(event);
		},
		logout() {
			//this.$emit('block-ui');

			// this.$axios.defaults.headers.common["Authorization"] = null;
			// this.$store.dispatch("logout");

			this.$router.push({ name: "Logout", params: { sessionExpired: "N" } });
		},
		changeLanguage(lang) {
			var self = this;
			self.$emit("block-ui");
			this.$axios.post(this.$API_URL + "util/change_language", { language: lang })
				.then((response) => {
					self.$root.$i18n.locale = lang;
					self.$axios.defaults.headers.common["language"] = lang;
					self.$store.dispatch("language", lang);
					self.$emit("unblock-ui");
				})
				.catch(function (err) {
					self.$emit("unblock-ui");
				})

		},
		readNotif() {
			//Send API to Flag all Read
		},
		toggleChangelog() {
			this.$emit('toggle-changelog');
		}
	},
	computed: {
		darkTheme() {
			return this.$appState.theme.startsWith('saga');
		},
		lang() {
			return this.$store.getters.getLanguage
		},
		badgeLang() {
			return (this.$store.getters.getLanguage).toUpperCase();
		},
		username() {
			return this.$store.getters.getUsername;
		},
		displayName() {
			return this.$store.getters.getFullname;
		},
		picName() {
			return this.$store.getters.getPICname;
		},
		languageItems() {
			return [
				{
					label: '(EN) English',
					icon: this.lang == "en" ? 'pi pi-check' : "",
					command: () => {
						this.changeLanguage('en');
					}
				},
				{
					label: '(ID) Indonesia',
					icon: this.lang == "id" ? 'pi pi-check' : "",
					command: () => {
						this.changeLanguage('id');
					}
				}
			];
		},
		items() {
			var dataItems = [
				{
					label: 'Logout',
					icon: 'pi pi-fw pi-power-off',
					command: () => {
						this.logout();
					}
				}
			];

			if (!this.$store.getters.getUseAD) {
				dataItems.unshift(
					{
						label: 'Change Password',
						icon: 'pi pi-fw pi-lock',
						command: () => {
							this.changePassword = true;
						}
					}
				)
			}

			return dataItems;
		},
		generalItems(){
 			return this.generalDataItems;
		}
	}
}
</script>